import React from "react";
import { Link } from "react-router-dom";

const CommonWellnessItem = ({ item }) => {
  // Check if item exists and has required properties
  if (!item || (!item.route && !item.action)) return null;

  const content = (
    <>
      <img
        src={item?.image}
        className="h-24 w-24 object-contain mt-4"
        alt={item?.name ?? "Wellness Item"}
      />
      <h4 className="text-center font-medium text-base py-4">
        {item?.name ?? "Unnamed Item"}
      </h4>
    </>
  );

  return item.route ? (
    <Link
      to={item.route}
      className="bg-white border border-slate-300 flex flex-col justify-center items-center py-6 rounded-xl hover:shadow-md transition-shadow"
    >
      {content}
    </Link>
  ) : (
    <button
      onClick={(e) => {
        e.preventDefault();
        if (item.action) item.action();
      }}
      className="bg-white border border-slate-300 flex flex-col justify-center items-center py-6 rounded-xl hover:shadow-md transition-shadow cursor-pointer"
    >
      {content}
    </button>
  );
};

export default CommonWellnessItem;
